<!--
 * @Author: zhaowh zhaowh@example.com
 * @Date: 2023-09-25 17:25:52
 * @LastEditors: zhaowh zhaowh@example.com
 * @LastEditTime: 2023-11-03 21:06:46
-->
<template>
  <el-main>
    <div class="top-wrap">
      <Bread></Bread>
    </div>
    <div class="main">
      <div class="title-wrap">
        <h2 class="title">添加账号</h2>
      </div>
      <el-form :model="form" :rules="rules" ref="ruleForm" label-width="160px">
        <div class="plate">
          <div class="title">账户信息</div>
          <el-form-item label="登录账号" prop="userName">
            <el-col class="col">
              <el-input
                v-model.trim="form.userName"
                placeholder="请填写登录账号"
                maxlength="30"
              ></el-input>
            </el-col>
            <span class="login-tip">6~20位字符，包含数字、字母。</span>
          </el-form-item>
          <el-form-item label="登录密码" prop="password">
            <el-col class="col">
              <el-input
                v-model.trim="form.password"
                :type="showPassword ? 'text' : 'password'"
                placeholder="请填写登录密码"
                autocomplete="new-password"
                maxlength="30"
              >
                <i
                  slot="suffix"
                  class="iconfont"
                  :class="{
                    'icon-mimaxianshi': showPassword,
                    'icon-mimayincang': !showPassword,
                  }"
                  @click="handleChangePassword('showPassword')"
                ></i>
              </el-input>
            </el-col>
            <span class="login-tip"
              >12~20位字符，包含数字、特殊字符、字母。</span
            >
          </el-form-item>
          <el-form-item label="法人" prop="ddCoop.legalPerson">
            <el-col class="col">
              <el-input
                v-model="form.ddCoop.legalPerson"
                placeholder="请填写法人"
              ></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="统一社会信用代码" prop="ddCoop.creditCode">
            <el-col class="col">
              <el-input
                v-model="form.ddCoop.creditCode"
                placeholder="请填写统一社会信用代码"
              ></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="注册地址" prop="ddCoop.registerAddress">
            <el-col class="col">
              <el-input
                v-model="form.ddCoop.registerAddress"
                placeholder="请填写注册地址"
              ></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="联系人" prop="ddCoop.contactName">
            <el-col class="col">
              <el-input
                v-model="form.ddCoop.contactName"
                placeholder="请填写姓名"
              ></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="手机号码" prop="phone">
            <el-col class="col">
              <el-input
                v-model.trim="form.phone"
                placeholder="请填写手机号码"
                oninput="valuevalue.replace(/[^\d]/g,'')"
                maxlength="11"
              ></el-input>
            </el-col>
          </el-form-item>
          <!-- <el-form-item label="银行机构" prop="name">
            <el-col class="col">
              <el-input
                v-model.trim="form.name"
                placeholder="请填写银行机构"
              ></el-input>
            </el-col>
          </el-form-item> -->
          <el-form-item prop="ddCoop.name" label="供销社">
            <el-col class="col">
              <el-input
                v-model="form.ddCoop.name"
                placeholder="请填写供销社名称"
              ></el-input>
              <!-- <el-autocomplete v-model="form.ddCoop.name" :fetch-suggestions="gxsAssociate" placeholder="请选择供销社，输入关键字查询选择" 
                label="name" value="value" value-key="name" :trigger-on-focus="false"></el-autocomplete> -->
            </el-col>
          </el-form-item>
          <el-form-item label="划分级别" prop="userLevel">
            <el-col class="col">
              <el-radio-group
                class="uav-type"
                @change="handleLevel"
                v-model="form.userLevel"
              >
                <el-radio
                  v-for="item in levels"
                  :label="item.id"
                  :key="item.id"
                >
                  {{ item.label }}
                </el-radio>
              </el-radio-group>
            </el-col>
          </el-form-item>
          <el-form-item label="服务地区" :prop="address">
            <el-col
              class="col col-select"
              :class="'col-select' + form.userLevel"
            >
              <el-select
                v-if="form.userLevel == 2 || form.userLevel == 3 || form.userLevel == 4"
                v-model="form.provinceId"
                placeholder="请选择省"
                @change="
                  handleChangeAddress(
                    form.provinceId,
                    'cityList',
                    'province'
                  )
                "
                style="width: 200px"
              >
                <el-option
                  v-for="(item, index) in provinceList"
                  :key="index"
                  :label="item.n"
                  :value="item.i"
                >
                  {{ item.n }}
                </el-option>
              </el-select>
              <el-select
                :disabled="form.provinceId ? false : true"
                v-if="form.userLevel == 3 || form.userLevel == 4"
                v-model="form.cityId"
                placeholder="请选择市"
                class="city-select"
                @change="
                  handleChangeAddress(form.cityId, 'areaList', 'city')
                "
              >
                <el-option
                  v-for="(item, index) in cityList"
                  :key="index"
                  :label="item.n"
                  :value="item.i"
                >
                  {{ item.n }}
                </el-option>
              </el-select>
              <el-select
                :disabled="form.cityId ? false : true"
                v-if="form.userLevel == 4"
                v-model="form.countyId"
                placeholder="请选择县"
                class="city-select"
                @change="handleChangeAddress(form.countyId, '', 'county')"
              >
                <el-option
                  v-for="(item, index) in areaList"
                  :key="index"
                  :label="item.n"
                  :value="item.i"
                >
                  {{ item.n }}
                </el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <el-form-item prop="ddCoop.checkedRegionData" label="所在位置">
            <el-col class="col">
              <el-cascader
                ref="regionCascader"
                :options="regionData"
                :props="regionProps"
                v-model="form.ddCoop.checkedRegionData"
                @change="handleRegionChange(form.ddCoop.checkedRegionData)"
                placeholder="服务区域"
              >
              </el-cascader>
            </el-col>
          </el-form-item>
          <el-form-item prop="ddCoop.address" label=" " class="w100">
            <el-col class="col my_col">
              <p class="address">{{form.ddCoop.address}}<span class="btn-text">点击地图获取位置</span></p>
              <div class="map-box" id="mapDiv"></div>
            </el-col>
          </el-form-item>
          <el-form-item class="form-item-submit" label-width="0">
            <el-button type="primary" @click="handleSubmit('ruleForm')"
            v-loading.fullscreen.lock="fullscreenLoading"
              >保存</el-button
            >
          </el-form-item>
        </div>
      </el-form>
    </div>
  </el-main>
</template>

<script>
import common from "@/utils/common.js";
import TalksMap from "@/utils/initMapTalks.js";
import * as maptalks from "maptalks";
import regionSeatLibs from '@/utils/regionSeatLibs.js'
let regionData = JSON.parse(JSON.stringify(regionSeatLibs[0].c))
export default {
  name: "AddSupply",
  data() {
    return {
        TalksMapDialog: new TalksMap(),
        fullscreenLoading:false,
        rules: {
            userLevel: [
            { required: true, message: "请选择划分级别", trigger: "blur" },
            ],
            provinceId: [
            { required: true, message: "请选择管辖地区", trigger: "change" },
            ],
            cityId: [
            { required: true, message: "请选择管辖地区", trigger: "change" },
            ],
            countyId: [
            { required: true, message: "请选择管辖地区", trigger: "change" },
            ],
            userName: [
            { required: true, message: "请填写登录账号", trigger: "blur" },
            { min: 6, max: 20, message: "长度在6到20位", trigger: "blur" },
            { trigger: "blur", validator: common.checkIdAccount },
            ],
            password: [
            { required: true, message: "请填写12-20位账号密码", trigger: "blur" },
            {
                min: 12,
                max: 20,
                message: "请输入12-20位账号密码",
                trigger: "blur",
            },
            { trigger: "blur", validator: common.checkIdPassword },
            ],
            ddCoop: {
              legalPerson: [
              { required: true, message: "请填写法人", trigger: "blur" },
              ],
              creditCode: [
              { required: true, message: "请填写统一社会信用代码", trigger: "blur" },
              ],
              registerAddress: [
              { required: true, message: "请填写注册地址", trigger: "blur" },
              ],
              contactName: [
              { required: true, message: "请填写联系人名称", trigger: "blur" },
              ],
              name: [
              { required: true, message: "请选择供销社", trigger: "blur" },
              ],
              checkedRegionData:{required: true, message: '请选择所在位置', trigger: 'change'},
              address:{ required: true, message: '请点击地图获取位置', trigger: 'change'},
            },
            phone: [
            { required: true, message: "请填写手机号码", trigger: "blur" },
            { validator: common.checkMobile, required: true, trigger: "blur" },
            ],
        },
        form: {
            provinceId: "", //住址省id
            province: "", //住址省name
            cityId: "", //住址市id
            city: "", //住址市name
            countyId: "", //所在地区县id
            county: "", //所在地区县name
            userName: "", // 登陆
            phone: "", // 手机
            password: "", // 密码
            userLevel: 2, // 划分级别
            address:'',//详细地址
            ddCoop:{
              legalPerson:'', // 法人
              creditCode:'', // 统一社会信用代码
              registerAddress:'', // 注册地址
              contactName: "", // 联系人
              name: "", // 供销社名称
              checkedRegionData:[],
              address:''
            }
        },
        
        regionData:regionData,
        regionProps: {
            value: 'i',
            label: 'n',
            children: 'c'
        },
        showPassword: false, // 是否展示密码
        levels: [
            { label: "省级", id: 2 },
            { label: "市级", id: 3 },
            { label: "县级", id: 4 },
        ], // 划分级别列表
        provinceList: [], // 省列表
        cityList: [], // 市列表
        areaList: [], // 区县列表
        loading:false,
    };
  },
  components: {},
  filters: {},
  watch: {
  },
  computed: {
    address() {
      let str;
      switch (this.form.userLevel) {
        case 2:
          str = "provinceId";
          break;
        case 3:
          str = "cityId";
          break;
        case 4:
          str = "countyId";
          break;
      }
      return str;
    },
  },
  created() {
    this.getSelectedCityOptions(1, "provinceList");
  },
  mounted() {
    this.mapInit();
  },
  destroyed() {
    this.map && this.map.removeEventListener('click', this.mapClickAddMaker)
  },
  methods: {
    // 下拉补贴地区选完关闭
    handleRegionChange(val) {
        this.$refs.regionCascader.dropDownVisible = false
        let _params = this.form.ddCoop
        _params.provinceId = val[0] || ''
        _params.cityId = val[1] || ''
        _params.countyId = val[2] || ''
    },
    /**
     * @description: 根据父id查询省市县乡村子地区
     * @Author: yangsibo
     * @Date: 2022-05-09 10:16:19
     * @param {string} pid 父级id
     * @param {string} type 赋值省市区数组
     * @param {*} name 省市区Name字段
     * @param {*} id 省市区对应数组
     */
    async getSelectedCityOptions(pid, type, name, id, loading) {
      try {
        let { data } = await this.$http.common.getChildRegion({ pid });
        this[type] = data;
        name && this.initCityName(id, name, data, loading);
      } catch (error) {}
    },
    /**
     * @description: 选中select后给name赋值同时获取子级数据
     * @Author: yangsibo
     * @Date: 2022-05-09 10:31:13
     * @param {*} pid
     * @param {*} type
     * @param {*} name
     * @return {*}
     */
    handleChangeAddress(pid, type, name) {
      let city = {};
      let list = "";
      switch (type) {
        case "cityList":
          this.form.cityId = "";
          this.form.countyId = "";
          this.cityList = [];
          this.areaList = [];
          list = "provinceList";
          break;
        case "areaList":
          this.form.countyId = "";
          this.areaList = [];
          list = "cityList";
          break;
        case "":
          list = "areaList";
          break;
        default:
          break;
      }
      city = this[list].find((item) => {
        return item.i == pid;
      });
      this.form[name] = city.n;
      type && this.getSelectedCityOptions(pid, type);
    },
    /**
     * @Description: change级别
     * @Author: yangsibo
     * @Date: 2022-11-09 17:02:09
     * @param {*} val
     * @return {*}
     */
    handleLevel(val) {
      if(val == 1) {
        let _form = this.form
        _form.provinceId = ''
        _form.cityId = ''
        _form.countyId = ''
      }
    },
    /**
     * @Description: 显示/隐藏 密码
     * @Author: yangsibo
     * @Date: 2022-10-14 14:44:54
     * @return {*}
     */
    handleChangePassword(type) {
      this[type] = !this[type];
    },
    /**
     * @Description: 保存县账号
     * @Author: yangsibo
     * @Date: 2022-09-29 10:24:38
     * @param {*} formName
     * @return {*}
     */
    handleSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.fullscreenLoading = true
          this.addCtCountyAccount();
        } else {
        }
      });
    },
    /**
     * @Description: 添加账号
     * @Author: yangsibo
     * @Date: 2022-09-29 10:44:52
     * @return {*}
     */
    async addCtCountyAccount() {
      let params= {
        ...this.form
      }
      console.log('params==',params)
      try {
        let { status } = await this.$http.supply.supplyMarketAdd(params);
        if (status == 1) {
          this.fullscreenLoading = false
          this.$message.success("添加供销社账号成功");
          this.$router.push({
            path: "/supply/manage/list",
          });
        }
      } catch (error) {
        this.fullscreenLoading = false
        console.log(error);
      }
    },
    /**
       * @description: 地图初始化
       * @param {*}
       * @return {*}
       */  
      mapInit() {
        console.log(window.T);
        const TMap = window.T
        if (this.map) return
        this.map = new TMap.Map('mapDiv')
        this.map.centerAndZoom(new TMap.LngLat(115.546174, 28.054632), 12)
        this.map.addEventListener('click', this.mapClickAddMaker)
      },

      async mapClickAddMaker(e) {
        console.log(e)
        const { lnglat } = e
        const geocoder = new window.T.Geocoder()
        geocoder.getLocation(lnglat, (result) => {
          if (result.getStatus() == 0) {
            const address = result.getAddress()
            this.createMakerWithInfoWindow({
              lonlat: e.lnglat,
              address,
            })
          }
        })
      },
      createMakerWithInfoWindow(addressDetail) {
        this.map && this.map.clearOverLays()
        const { lonlat, address, name } = addressDetail
        const T = window.T
        const icon = new T.Icon({
          iconUrl: require('@/assets/biaozhu_dingwei.png'),
          iconSize: new T.Point(22, 32),
          iconAnchor: new T.Point(10, 25),
        })
        const { lng, lat } = lonlat
        this.form.ddCoop.lng = lng;
        this.form.ddCoop.lat = lat;
        const marker = new T.Marker(new T.LngLat(lng, lat), { icon })
        this.map.addOverLay(marker)
        const addressInfo = name ? `${address}${name}` : address
        this.form.ddCoop.address = addressInfo;
      },
      // mapInit(){
      //   this.TalksMapDialog.sendThis(this);
      //   let center = [115.546174, 28.054632];
      //   let user = JSON.parse(localStorage.getItem("user"));
      //   if (user.lng && user.lat) center =[Number(user.lng),Number(user.lat)];
      //   this.TalksMapDialog.init("mapDiv", 17, center);
      //   this.pic1Marker = new maptalks.VectorLayer("pic1Marker").addTo(
      //     this.TalksMapDialog.map
      //   );
      //   // 监听地图点击事件
      //   this.TalksMapDialog.map.on("click", (param) => {
      //     let lng = Number(param.coordinate.x),lat = Number(param.coordinate.y);
      //     this.form.ddCoop.lng = lng;
      //     this.form.ddCoop.lat = lat;
      //     this.markerOnClick(lng,lat);
      //     // this.getAddressByLngLat(lat,lng,(res) => {
      //     //   this.form.address = res.address;
      //     // })
      //   });
      // },
      /**
       * @description: 地图标记点点击事件
       * @param {*}
       * @return {*}
       */    
      // markerOnClick(lng,lat){
      //   this.pic1Marker && this.pic1Marker.clear();
      //   //向地图上添加自定义标注
      //   const marker = new maptalks.Marker(
      //     [lng,lat],
      //     {
      //       symbol: [
      //         {
      //           markerFile: require("@/assets/biaozhu_dingwei.png"),
      //           markerWidth: 22,
      //           markerHeight: 32,
      //           markerOpacity: 1,
      //         },
      //       ],
      //     }
      //   ).addTo(this.pic1Marker);
      // },
      /**
       * @description: 根据经纬度获取详细地址
       * @param {*}
       * @return {*}
       */   
    //   async getAddressByLngLat(lat,lng,fn) {
    //     let coords = lat + "," +lng
    //     let {result} = await geocoder({coords:coords});
    //     fn(result);
    //   },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/common.scss";
@import "@/styles/mixin.scss";

.main {
  .title-wrap {
    @include plate-title-mutil;
    height: 44px;
    border-bottom: 1px solid #efefef;
    margin-bottom: 16px;
    padding-bottom: 10px;
    box-sizing: border-box;

    .title {
      font-size: 20px;
      font-weight: bold;
      color: #018388;
    }
  }

  ::v-deep .el-form {
    width: 1000px;
    padding: 10px 20px;
    .plate {
      .title {
        font-size: 18px;
        color: #333333;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        &:before {
          content: "";
          display: inline-block;
          width: 5px;
          height: 18px;
          background: #018388;
          border-radius: 3px;
          margin-right: 5px;
        }
      }
      .el-form-item__content {
        display: flex;
        }
    }
    .my_col {
      width: 75% !important;
    }
    .col {
      width: 360px;

      &.domain-col {
        width: 565px;

        .el-input {
          input {
            text-align: right;
            padding-right: 50px;

            &::-webkit-input-placeholder {
              text-align: left;
            }

            &::-moz-placeholder {
              text-align: left;
            }

            &::-ms-input-placeholder {
              text-align: left;
            }
          }

          .el-input__suffix-inner {
            i {
              display: inline-block;
              height: 100%;
              line-height: 40px;
              color: #606266;
              font-style: inherit;
            }
          }
        }
      }

      &.col-select {
        width: 600px;
        display: flex;
      }

      &.col-select2 {
        width: 200px;
      }

      &.col-select3 {
        width: 400px;
      }

      &.col-select4 {
        width: 600px;
      }
    }

    .login-tip {
      position: absolute;
      top: 32px;
      color: #999;
      font-size: 12px;
    }

    .form-item-submit {
      display: flex;
      align-items: center;
      justify-content: center;

      .el-form-item__content {
        margin-right: 450px;
      }
    }

    .el-form-item {
      margin-bottom: 22px;

      .city-select {
        width: 200px !important;
        margin-left: 10px;
      }
      .address{
          font-size: 16px;
          color: #333333;
          .btn-text{
            color: #01AA43;
            text-decoration: underline;
            margin-left: 4px;
          }
        }
        &.w100{
          width: 100%;
          .map-box{
            width: 56vw;
            height: 400px;
          }
          .el-textarea{
            width: 56vw;
            
          }
        }
    }
    .el-form-item__error {
        position: relative;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 10px;
        padding-top: 0;
      }
      .el-cascader {
          width: 360px;
      }

    
  }
}
::v-deep {
  .el-autocomplete {
    width: 100% !important;
  }
  .my-input {
    width: 360px;
  }
}
</style>
